import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCasePathSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    return super.parse(this.handleUrl(url));
  }

  handleUrl(url: string): string {
    // Have angular recognize E360 URL paths that are manually typed in by users with case insensitivity
    // Query params and plugin route paths are not touched as part of this serializer

    const urlParts: string[] = url.split('?');
    const path: string = urlParts[0];
    const params: string = urlParts[1];

    const pathParts: string[] = path.split('/app/');
    const lowerShellPath: string = pathParts[0].toLowerCase();
    const pluginPath: string = pathParts[1];
    const adjustedPath: string = pluginPath ? `${lowerShellPath}/app/${pluginPath}` : lowerShellPath;

    return params ? `${adjustedPath}?${params}` : adjustedPath;
  }
}
